import { Helmet } from 'react-helmet';
import Header from '../../../components/header';
import Navbar from '../../../components/NavBar';
import OnBaseDocumentsTable from '../components/OnBaseDocumentsTable'
import useGetOnBaseDocuments from '../hooks/useGetOnBaseDocuments'
import { GetOnBaseDocumentsRequest } from '../types/GetOnBaseDocumentsRequest';
import RequeueFailedDocument from '../api/RequeueFailedDocument'
import DeleteFailedDocument from '../api/DeleteFailedDocument';
import DownloadFailedDocument from '../api/DownloadFailedDocument';
import { OnBaseDocumentData } from '../types/OnBaseDocumentData';
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from '../../../auth/AuthConfig';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useState } from 'react';
import '../../../styles/dashboardStyles.css';

function OnBaseFailedDocumentsPage() {

  let paramvalues: GetOnBaseDocumentsRequest = {
    rowKey: "",
    partitionKey: "ToOnBase",
    MaxRetries: 5,
    OnBaseReceived: false,
    IsDeleted: false
  }

  const [RefreshFlag, setRefreshFlag] = useState(0);
  const { Data, loading } = useGetOnBaseDocuments(paramvalues, RefreshFlag);

  useEffect(() => {
    const interval = setInterval(() => {
      setRefreshFlag((prev) => prev + 1);
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  function handleRequeueDocument(doc: OnBaseDocumentData) {
    RequeueFailedDocument(doc)
    setRefreshFlag((prev) => prev + 1)
  }

  function handleDeleteDocument(doc: OnBaseDocumentData) {
    DeleteFailedDocument(doc)
    setRefreshFlag((prev) => prev + 1)
  }

  function handleDownloadDocument(doc: OnBaseDocumentData) {
    DownloadFailedDocument(doc)
    setRefreshFlag((prev) => prev + 1)
  }

  if (loading) return <p>Please Wait...</p>;

  return (
    <>

      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={loginRequest}
      >
        <div className="full-height-form p-fluid">
          <Helmet>
            <title>OnBase Failed Documents</title>
          </Helmet>
          <Header />
          <Navbar />
          <h1 className='Ph1'>OnBase Failed Documents</h1>
          <OnBaseDocumentsTable DataList={Data} handleRequeueDocument={handleRequeueDocument} handleDeleteDocument={handleDeleteDocument} handleDownloadDocument={handleDownloadDocument} />
        </div>
      </MsalAuthenticationTemplate>

    </>

  )
}

export default OnBaseFailedDocumentsPage
